import { ChevronsRight } from 'lucide-react'
import { cn } from '~/@/lib/utils'

/**
 * Renders button on the Doss Table to collapse or expand the pivot table nav
 */
export const CollapsePivotTableNavButton = ({
  pivotTableNavOpen = false,
  setPivotTableNavOpen,
  hidePivotTableButtons = false,
  hideTableExpander = false,
}: {
  pivotTableNavOpen?: boolean
  setPivotTableNavOpen?: (open: boolean) => void
  hidePivotTableButtons?: boolean
  hideTableExpander?: boolean
}) => {
  return (
    <div
      className={cn(
        `item-center absolute start-1 w-6 cursor-pointer text-gray-8 opacity-0 transition duration-300`,
        !hidePivotTableButtons && 'group-hover/dtable:opacity-100',
        (pivotTableNavOpen || hideTableExpander) && 'hidden',
      )}
      onClick={(e) => {
        e.stopPropagation()
        setPivotTableNavOpen?.(true)
      }}
    >
      <ChevronsRight size={12} />
    </div>
  )
}
